import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <TopicsSection />
        <CardsSection />
        <FeaturesSection />
        <AboutSection />
        <MediaSection />
        <CarouselSection />
        <UpdatesSection />
        <AppSection />
        <ContactSection />
        <CommentsSection />
        <FaqSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}